export function navigation() {
    const header = document.querySelector('[data-header]');
    if (!header) return;

    const toggle = header.querySelector('.header__menu-toggle');
    const menu = header.querySelector('.header__side');
    const backdrop = document.querySelector('[data-menu-close]');
    const dropdownTriggers = header.querySelectorAll('.nav__dropdown-trigger');
    const mobileQuery = window.matchMedia('(max-width: 991px)');

    if (!toggle || !menu) return;

    // Delay voordat een desktop dropdown sluit.
    // Hierdoor kun je makkelijker diagonaal richting het mega menu bewegen.
    const dropdownCloseDelay = 500;

    // Slaat per dropdown een eventuele sluit-timeout op.
    const dropdownTimeouts = new WeakMap();


    /**
     * Open het mobiele navigatiemenu.
     */
    const openMenu = () => {
        header.classList.add('is-menu-open');
        document.body.classList.add('menu-open');

        toggle.setAttribute('aria-expanded', 'true');
        toggle.setAttribute('aria-label', 'Menu sluiten');
        menu.setAttribute('aria-hidden', 'false');
    };


    /**
     * Sluit het mobiele navigatiemenu.
     */
    const closeMenu = () => {
        header.classList.remove('is-menu-open');
        document.body.classList.remove('menu-open');

        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', 'Menu openen');
        menu.setAttribute('aria-hidden', mobileQuery.matches ? 'true' : 'false');
    };


    /**
     * Open een desktop dropdown.
     */
    const openDropdown = (trigger) => {
        if (mobileQuery.matches) return;

        const item = trigger.closest('.nav__item');
        if (!item) return;

        // Annuleer een geplande sluiting van deze dropdown.
        clearTimeout(dropdownTimeouts.get(item));

        // Sluit eventuele andere geopende dropdowns.
        dropdownTriggers.forEach((otherTrigger) => {
            if (otherTrigger === trigger) return;

            const otherItem = otherTrigger.closest('.nav__item');
            if (!otherItem) return;

            clearTimeout(dropdownTimeouts.get(otherItem));

            otherTrigger.setAttribute('aria-expanded', 'false');
            otherItem.classList.remove('is-open');
        });

        trigger.setAttribute('aria-expanded', 'true');
        item.classList.add('is-open');
    };


    /**
     * Sluit een desktop dropdown direct.
     */
    const closeDropdown = (trigger) => {
        const item = trigger.closest('.nav__item');
        if (!item) return;

        clearTimeout(dropdownTimeouts.get(item));

        trigger.setAttribute('aria-expanded', 'false');
        item.classList.remove('is-open');
    };


    /**
     * Plan het sluiten van een dropdown.
     *
     * De kleine vertraging zorgt ervoor dat de dropdown niet meteen
     * verdwijnt wanneer de muis kort buiten het hovergebied komt.
     */
    const scheduleDropdownClose = (trigger) => {
        const item = trigger.closest('.nav__item');
        if (!item) return;

        clearTimeout(dropdownTimeouts.get(item));

        const timeout = setTimeout(() => {
            closeDropdown(trigger);
        }, dropdownCloseDelay);

        dropdownTimeouts.set(item, timeout);
    };


    /**
     * Mobile menu toggle.
     */
    toggle.addEventListener('click', () => {
        header.classList.contains('is-menu-open')
            ? closeMenu()
            : openMenu();
    });


    /**
     * Sluit mobiel menu via backdrop.
     */
    backdrop?.addEventListener('click', closeMenu);


    /**
     * Sluit het mobiele menu wanneer buiten de navigatie wordt geklikt.
     */
    document.addEventListener('click', (event) => {
        if (
            !header.classList.contains('is-menu-open') ||
            menu.contains(event.target) ||
            toggle.contains(event.target)
        ) {
            return;
        }

        closeMenu();
    });


    /**
     * Sluit mobiel menu na het aanklikken van een link.
     */
    menu.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', closeMenu);
    });


    /**
     * Desktop dropdowns.
     */
    dropdownTriggers.forEach((trigger) => {
        const item = trigger.closest('.nav__item');
        if (!item) return;

        /**
         * Open dropdown direct bij hover.
         */
        item.addEventListener('mouseenter', () => {
            openDropdown(trigger);
        });


        /**
         * Sluit dropdown met een kleine vertraging.
         */
        item.addEventListener('mouseleave', () => {
            scheduleDropdownClose(trigger);
        });


        /**
         * Ondersteuning voor toetsenbordnavigatie.
         */
        item.addEventListener('focusin', () => {
            openDropdown(trigger);
        });


        /**
         * Sluit wanneer focus helemaal buiten het item terechtkomt.
         */
        item.addEventListener('focusout', (event) => {
            if (item.contains(event.relatedTarget)) return;

            scheduleDropdownClose(trigger);
        });


        /**
         * Dropdown blijft ook klikbaar op desktop.
         */
        trigger.addEventListener('click', () => {
            if (mobileQuery.matches) return;

            const isOpen = trigger.getAttribute('aria-expanded') === 'true';

            if (isOpen) {
                closeDropdown(trigger);
                return;
            }

            openDropdown(trigger);
        });
    });


    /**
     * Synchroniseer gedrag wanneer desktop/mobile breakpoint verandert.
     */
    const syncNavigationMode = () => {
        dropdownTriggers.forEach((trigger) => {
            const item = trigger.closest('.nav__item');

            if (item) {
                clearTimeout(dropdownTimeouts.get(item));
                item.classList.remove('is-open');
            }

            trigger.disabled = mobileQuery.matches;
            trigger.setAttribute(
                'aria-expanded',
                String(mobileQuery.matches)
            );
        });
    };


    /**
     * Escape sluit zowel mobiele navigatie als desktop dropdowns.
     */
    document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;

        dropdownTriggers.forEach((trigger) => {
            closeDropdown(trigger);
        });

        if (header.classList.contains('is-menu-open')) {
            closeMenu();
            toggle.focus();
        }
    });


    /**
     * Navigatie opnieuw instellen bij breakpoint-wijziging.
     */
    mobileQuery.addEventListener('change', () => {
        closeMenu();
        syncNavigationMode();
    });


    // Initiële state.
    syncNavigationMode();

    menu.setAttribute(
        'aria-hidden',
        mobileQuery.matches ? 'true' : 'false'
    );
}